export const DEFAULT_SHEET_PARAMETER_DATA = {
    max_limit: null,
    min_limit: null,
    frecuency: null,
    frequency_duration: null,
    monthly_frequency_day: null,
    semanal_frequency: null,
    reminder_time: null,
    preconfig_id: null
};